import { render, staticRenderFns } from "./guild-page.vue?vue&type=template&id=203cc74c&scoped=true&lang=pug&"
import script from "./guild-page.vue?vue&type=script&lang=js&"
export * from "./guild-page.vue?vue&type=script&lang=js&"
import style0 from "./guild-page.vue?vue&type=style&index=0&id=203cc74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203cc74c",
  null
  
)

export default component.exports